(function(){
    'use strict';

    if (document.body.classList.contains('no-react')) {

        var mobile_toggle = document.querySelector('.header__mobile-toggle');
        var nav_panel = document.querySelector('.nav-panel');
        mobile_toggle.addEventListener('click', toggleActiveMobile);

        function toggleActiveMobile() {
            mobile_toggle.classList.toggle('active');
            nav_panel.classList.toggle('active');
        }



        var search_toggle = document.querySelector('.header__search-toggle');
        search_toggle.addEventListener('click', toggleActiveSearch);

        function toggleActiveSearch() {
            search_toggle.classList.toggle('active');
        }
    }
    
}());
